// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import request from './request'

const serveName = process.env.VUE_APP_SERVENAME

const sandboxServeName = 'PaySandbox'

// 商品配置
// 同步线上商品
export const syncProductFetch = (data?: object) => request(`/${serveName}/product/syncProduct`, null, 'POST_JSON', data)

// 场景配置
// 获取场景分类列表
export const getScenarioListFetch = (data?: object) =>
  request(`/${sandboxServeName}/scenario/getScenarioList`, null, 'POST_JSON', data)

// 获取场景子分类[场景管理]列表
export const getSubScenarioListFetch = (data?: object) =>
  request(`/${sandboxServeName}/scenario/getSubScenarioList`, null, 'POST_JSON', data)

// 新增/修改场景子分类
export const addSubScenarioFetch = (data?: object) =>
  request(`/${sandboxServeName}/scenario/addSubScenario`, null, 'POST_JSON', data)

// 删除测试子场景
export const deleteSubScenarioFetch = (data?: object) =>
  request(`/${sandboxServeName}/scenario/deleteSubScenario`, null, 'POST_JSON', data)

// 测试配置
// 通过dbtId查询沙盒测试设备
export const getTestDeviceListFetch = (data?: object) =>
  request(`/${sandboxServeName}/testConfig/getTestDeviceList`, null, 'POST_JSON', data)

// 新增沙盒测试设备
export const addTestDeviceFetch = (data?: object) =>
  request(`/${sandboxServeName}/testConfig/addTestDevice`, null, 'POST_JSON', data)

// 删除沙盒测试设备
export const deleteTestDeviceFetch = (data?: object) =>
  request(`/${sandboxServeName}/testConfig/deleteTestDevice`, null, 'POST_JSON', data)

// 查询测试配置
export const getTestConfigListFetch = (data?: object) =>
  request(`/${sandboxServeName}/testConfig/getTestConfigList`, null, 'POST_JSON', data)

// 新增/修改测试配置
export const addTestConfigFetch = (data?: object) =>
  request(`/${sandboxServeName}/testConfig/addTestConfig`, null, 'POST_JSON', data)

// MOCK订单查询
export const getMockOrderListFetch = (data?: object) =>
  request(`/${sandboxServeName}/thirdOrder/getOrderList`, null, 'POST_JSON', data)

// 渠道Mock配置管理
// 查询渠道Mock配置（不传id/payChnl为分页列表；传id或payChnl返回单条详情）
export const getChannelMockConfigFetch = (data?: object) =>
  request(`/${sandboxServeName}/channelMockConfig/get`, null, 'POST_JSON', data)

// 新增或更新渠道Mock配置（id为空新增，否则更新）
export const saveChannelMockConfigFetch = (data?: object) =>
  request(`/${sandboxServeName}/channelMockConfig/save`, null, 'POST_JSON', data)

// 删除渠道Mock配置（按id物理删除）
export const removeChannelMockConfigFetch = (data?: object) =>
  request(`/${sandboxServeName}/channelMockConfig/remove`, null, 'POST_JSON', data)
